import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import logo from '../assets/logo.png';
import fondo from '../assets/imagen10.jpeg';

const WelcomeScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        signOut(auth)
          .then(() => {
            console.log('Sesión cerrada automáticamente al volver al inicio');
          })
          .catch((error) => {
            console.error('Error al cerrar sesión:', error);
          });
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={{ ...styles.outerContainer, backgroundImage: `url(${fondo})` }}>
      <div style={styles.overlay} />
      <div style={styles.card}>
        <img src={logo} alt="Logo Mariana Fitness" style={styles.logo} />

        <h1 style={styles.title}>Bienvenido a Mariana Fitness Trainer</h1>
        <p style={styles.subtitle}>Elige una opción para comenzar</p>

        <div style={styles.buttonGroup}>
          <button onClick={() => navigate('/login')} style={styles.button}>
            Iniciar sesión
          </button>
          <button onClick={() => navigate('/plans')} style={styles.button}>
            Registrarse
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;

const styles = {
  outerContainer: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // <-- centrado horizontalmente
    position: 'relative',
    padding: 20
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    padding: '40px 30px',
    borderRadius: 16,
    boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: 500,
    width: '100%',
    zIndex: 2
  },
  logo: {
    width: 180,
    marginBottom: 20
  },
  title: {
    color: '#6e1d3c',
    marginBottom: 8,
    fontSize: 24
  },
  subtitle: {
    color: '#333',
    marginBottom: 20
  },
  buttonGroup: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  button: {
    padding: '10px 24px',
    backgroundColor: '#b03060',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 16,
    minWidth: 140
  }
};




// Responsive override with media queries
// const mediaQuery = window.matchMedia('(max-width: 768px)');
// if (mediaQuery.matches) {
  // styles.contentWrapper.justifyContent = 'center';
//}

